import { render, staticRenderFns } from "./PcCopyable.vue?vue&type=template&id=b530645a"
import script from "./PcCopyable.vue?vue&type=script&lang=js"
export * from "./PcCopyable.vue?vue&type=script&lang=js"
import style0 from "./PcCopyable.vue?vue&type=style&index=0&id=b530645a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports